export enum OutgoingInvoiceListTabsEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  TEMPLATE = 'template',
  ALL = 'all',
}
